<template>
  <div>
    <form
      autocomplete="off"
      @submit.prevent="updateProductoCodigoRastreo"
    >
      <AtomInputPrimary
        v-model="codigoRastreo.nombre"
        :inputError="$v.codigoRastreo.nombre.$error"
        :label="$t('mEditionProductTrackingCodesEdit.inputs.nombre.label')"
        :message="$t('mEditionProductTrackingCodesEdit.inputs.nombre.message')"
        :messageError="messageErrorNombre"
        name="nombre"
        :placeholder="$t('mEditionProductTrackingCodesEdit.inputs.nombre.placeholder')"
        type="text"
        @blur="$v.codigoRastreo.nombre.$touch()"
      />

      <AtomTextAreaPrimary
        v-model="codigoRastreo.codigo_head"
        :inputError="$v.codigoRastreo.codigo_head.$error"
        :label="$t('mEditionProductTrackingCodesEdit.inputs.codigo_head.label')"
        :messageError="messageErrorCodigoHead"
        name="codigo_head"
        rows="8"
        @blur="$v.codigoRastreo.codigo_head.$touch()"
      />

      <AtomTextAreaPrimary
        v-model="codigoRastreo.codigo_body"
        :inputError="$v.codigoRastreo.codigo_body.$error"
        :label="$t('mEditionProductTrackingCodesEdit.inputs.codigo_body.label')"
        :messageError="messageErrorCodigoBody"
        name="codigo_body"
        rows="8"
        @blur="$v.codigoRastreo.codigo_body.$touch()"
      />

      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'
// import { validateScriptTags } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionProductTrackingCodesEdit',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductTrackingCodesEdit.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      codigoRastreo: {
        codigo_body: '',
        codigo_head: '',
        id_codigo_rastreo: '',
        nombre: ''
      }
    }
  },

  validations: {
    codigoRastreo: {
      codigo_body: {
        required: requiredIf(function () {
          return !this.codigoRastreo.codigo_head.length
        })
        // validScript: validateScriptTags
      },

      codigo_head: {
        required: requiredIf(function () {
          return !this.codigoRastreo.codigo_body.length
        })
        // validScript: validateScriptTags
      },

      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      }
    }
  },

  computed: {
    messageErrorCodigoBody () {
      return this.$validation.getValidationMessage('mEditionProductTrackingCodesEdit', this.$v.codigoRastreo.codigo_body, 'codigo_body')
    },

    messageErrorCodigoHead () {
      return this.$validation.getValidationMessage('mEditionProductTrackingCodesEdit', this.$v.codigoRastreo.codigo_head, 'codigo_head')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionProductTrackingCodesEdit', this.$v.codigoRastreo.nombre, 'nombre')
    }
  },

  created () {
    this.codigoRastreo = Object.assign({}, this.$store.getters.getProductSelectedTrackingCode)

    if (Object.keys(this.codigoRastreo).length === 0) {
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.trackingCodes.subject')}`)
    }

    console.log(this.codigoRastreo)
  },

  methods: {
    updateProductoCodigoRastreo () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        // this.codigoRastreo.codigo_body = this.$utils.parseScriptTags(this.codigoRastreo.codigo_body)
        // this.codigoRastreo.codigo_head = this.$utils.parseScriptTags(this.codigoRastreo.codigo_head)
        this.$services.create('producto', 'updateProductoCodigoRastreo', this.codigoRastreo, [this.$route.params.id, this.codigoRastreo.id_producto_codigo_rastreo])
          .then(response => {
            this.$modal.updateData('readElement')
            this.$alerts.pushAlert('mEditionProductTrackingCodesEdit', 'updateProductoCodigoRastreo', 'success')
            this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.trackingCodes.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductTrackingCodesEdit', 'updateProductoCodigoRastreo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
